'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var DEFAULT_ITEMS_PER_PAGE_OPTIONS = [12, 24, 48, 96];

exports.DEFAULT_ITEMS_PER_PAGE_OPTIONS = DEFAULT_ITEMS_PER_PAGE_OPTIONS;
//# sourceMappingURL=constants.js.map
